import React, {Component} from 'react';
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {PutWithAuth} from "../../api/client/Put";

class UserAccounts extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: "admin",
            password: "",
            submitted: false
        };
    }

    handleChange = (event) => {
        let field = event.target.name;
        let val = event.target.value;

        this.setState({
            [field]: val
        });
    };

    submit = () => {
        PutWithAuth(
            "/api/login",
            this.props.token,
            {
                username: this.state.username,
                password: this.state.password
            })
        .then((res) => {
            this.setState({
                submitted: true,
                status: res.data
            })
        })
    };

    render() {
        return (
            <React.Fragment>
                <h2>Change Password</h2>
                <TextField
                    label={"Username"}
                    name={"username"}
                    value={this.state.username}
                    onChange={e => this.handleChange(e)}
                    margin="normal"
                    disabled
                />
                <br/>
                <TextField
                    label={"Password"}
                    name={"password"}
                    value={this.state.password}
                    onChange={e => this.handleChange(e)}
                    margin="normal"
                    type={"password"}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this.submit()
                        }
                    }}
                />
                <div style={{width: "100%"}}>
                    <Button variant="outlined" color="primary"
                            onClick={e => this.submit()}>
                        Change Password
                    </Button>
                </div>
                {
                    this.state.submitted && <p>{this.state.status}</p>
                }
            </React.Fragment>

        );
    }
}

export default UserAccounts;